var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'item-card',
    ("is-" + _vm.ics_type),
    { phone: _vm.$md.phone(), tablet: _vm.$md.tablet() } ]},[_c('span',{staticClass:"ics-tag"},[_vm._v(_vm._s(_vm.icsTagText))])])}
var staticRenderFns = []

export { render, staticRenderFns }